"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.noWait = noWait;
async function noWait() {
    return new Promise((resolve) => {
        if (typeof setImmediate === 'function') {
            setImmediate(() => resolve());
        }
        else {
            // didn't find a better way to do it in the browser
            setTimeout(() => resolve(), 0);
        }
    });
}
//# sourceMappingURL=noWait.js.map